import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { LoginService } from './login.service';

@Injectable()
export class LoginRouteGuard implements CanActivate {

  urlLogin = '/auth/login';

  constructor(private loginService: LoginService, private router: Router) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    // Si el enrutado se dirige a la ventana de login
    if (next.url.length > 0 && next.url[0].path === 'auth') {
      // Si estaba logeado
      if (this.loginService.isLoggedIn()) {
          // Se le envía al raíz para que entre en la aplicación
          this.router.navigate(['/']);
          // No se le permite al enrutador ir a Login
          return false;
      } else {
          // Si se le permite al enrutador ir a Login
          return true;
      }
  }

  // Si no se dirige a Login y está logado
  if (this.loginService.isLoggedIn()) {
      // Permitimos que navege al destino
      return true;
  }

  // Si no se dirige a Login y no está logado, le reenviamos a la ventana de Login
  this.router.navigate([this.urlLogin]);
  return false;

  }
}



// WEBPACK FOOTER //
// ./src/app/services/auth-guard.service.ts